import clsx from "clsx"
import _ from "lodash"
import React from "react"
import { Container } from "react-bootstrap"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import useNews from "../../hooks/dataHooks/useNews"
import NewsCard from "../NewsCard/NewsCard"
import "./OtherNewsSlider.scss"
import Animation from "../elements/Animation"

const OtherNewsSlider = ({ newsID }) => {
  const allNews = useNews()

  const filteredNews = Array.isArray(allNews) && newsID
    ? allNews.filter(news => String(news.strapi_id) !== String(newsID))
    : [];

  if (!filteredNews.length) return null;

  const settings = {
    dots: false,
    infinite: filteredNews.length > 1, // only enable loop when more than 1
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  }

  return (
    <Animation className={clsx("news-slider-wrap section-p-120")}>
      <Container className="news-slider-container">
        <h2 className="title">
          May also <i>interest</i> you...
        </h2>
        <div className="slider-section">
          <Slider {...settings}>
            {filteredNews.map((news, index) => (
              <NewsCard key={news.strapi_id} news={news} />
            ))}
          </Slider>
        </div>
      </Container>
    </Animation>
  )
}

export default OtherNewsSlider
